import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useSWR from "swr";
import { useAuth } from "../../../../Context/AuthContext";
import QueryString from "qs";
import { orderUrls } from "../../../../Api/Auth/ApiUrls";
import { fileFetcher } from "../../../../Api/swrConfig";
import Table from "../../../../Components/Common/Table";
import TableHead from "../../../../Components/Common/TableHead";
import LiveClassRow from "../Components/LiveClassRow";
import { Loader } from "../../../../Components/Common/Loader";
import NoData from "../../../../Components/Common/NoData";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import Tabs from "../../../../Components/Common/Tabs";
import { studentLiveClassTabsData } from "../../../../data/SidebarData";
import Accordion from "../../../Home/Components/Accordion";
import Button from "../../../../Components/Common/Button";
import { publicUrls, studentUrls } from "../../../../Api/Auth/AppUrls";
import Modal from "../../../../Components/Common/Modal";
import LiveClassDetails from "../Components/LiveClassDetails";
import VideoModal from "../../../../Components/Common/VideoModal";
import { checkStudentRouteVisibility } from "../../../../utils/findStudentRouteBySlug";
import NotFound from "../../../Notfound";

const tableColumnData = [
  { id: "title", label: "Title" },
  { id: "date", label: "Date" },
  { id: "time", label: "Time" },
  { id: "duration", label: "Duration (Hours)" },
  { id: "action", label: "Actions" },
];
const StudentLiveClassMechanical = () => {
  const location = useLocation();
  const { userData, categoryData } = useAuth();
  const [item, setItem] = useState(null);
  const parts = location.pathname.split("/").filter(Boolean);
  const dynamicPath = `/${parts[0]}/${parts[1]}-${parts[2]}`;
  const dynamicSlug = dynamicPath.split("/")[dynamicPath.split("/").length - 1];
  const isVisibleCivil = checkStudentRouteVisibility(
    categoryData,
    studentUrls.liveClass
  );
  const isVisibleMechanical = checkStudentRouteVisibility(
    categoryData,
    studentUrls.liveClassMechanical
  );
  const visibleTabs = studentLiveClassTabsData.filter((tab) => {
    if (!tab?.path) return true;
    if (tab.path === studentUrls.liveClass && !isVisibleCivil) return false;
    if (tab.path === studentUrls.liveClassMechanical && !isVisibleMechanical)
      return false;
    return true;
  });
  const apiQueryParams = {
    userId: userData?._id,
    itemType: "liveClassSubscription",
    slug: dynamicSlug,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState(null);

  const { isLoading, data, mutate } = useSWR(
    orderUrls.purchases(apiQueryString)
  );

  const onClick = (row) => {
    setItem(row);
  };

  const { data: videoUrl, isLoading: videoLoading } = useSWR(
    item?.recordingLink,
    (url) => fileFetcher(url)
  );

  useEffect(() => {
    if (videoUrl && item) {
      setVideoSrc(videoUrl);
    }
    return () => {
      if (videoUrl && item) URL.revokeObjectURL(videoUrl); // Cleanup the object URL
    };
  }, [videoUrl, item]);

  const dataRender = data?.data?.map((item, index) => ({
    title: item.title,
    content: (
      <div className="flex flex-col gap-3">
        <span className="font-normal text-xs">{item.description}</span>
        <Table key={index}>
          <TableHead
            rowCount={item?.liveClasses}
            headerData={tableColumnData}
          />
          <tbody className={`divide-y divide-gray-200`}>
            {!isLoading ? (
              <>
                {item?.liveClasses?.map((row) => (
                  <LiveClassRow
                    key={row._id}
                    row={row}
                    mutate={mutate}
                    onClick={onClick}
                    setIsModalOpen={setIsModalOpen}
                    setIsDetailsModalOpen={setIsDetailsModalOpen}
                  />
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="100" className="text-center py-4">
                  <Loader />
                </td>
              </tr>
            )}
          </tbody>
          <NoData isNotFound={!item?.liveClasses.length && !isLoading} />
        </Table>
      </div>
    ),
  }));

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={visibleTabs} />
      {!isVisibleMechanical ? (
        <NotFound />
      ) : (
        <>
          {data?.data?.length ? (
            <Accordion accordionData={dataRender} fullWidth openFirst />
          ) : (
            <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
              No available content. Purchase a Live Class to get started.
              <Link to={publicUrls.LiveClassMechanical}>
                <Button>Live Class</Button>
              </Link>
            </span>
          )}
          <Modal
            isOpen={item !== null && isDetailsModalOpen}
            title={"View Live Class Details"}
            // onConfirm={handleSubmit}
            onCancel={() => {
              setItem(null);
            }}
            footer={false}
            formWidth={true}
          >
            <LiveClassDetails data={item} setIsModalOpen={setIsModalOpen} />
          </Modal>

          <VideoModal
            videoSrc={videoSrc}
            isOpen={isModalOpen}
            onCancel={() => {
              setIsModalOpen(false);
            }}
            isLoading={videoLoading}
          />
        </>
      )}
    </div>
  );
};

export default StudentLiveClassMechanical;
